<template>
  <div class="hz-bar-container mt-1">
    <div
      class="hz-bar-left"
      :class="{ hide: leftFlag, borderRadiusRight: rightFlag }"
      :style="{
        width: `${calculateLeftBar}` + '%',
      }"
      v-b-tooltip.hover
      :title="data.length > 0 ? '$' + data[0].toFixed(2) : ''"
    >
      <div class="bar-left-data">
        <span> {{ inlineData ? '$' + data[0].toFixed(2) : '' }}</span>
      </div>
    </div>
    <div
      class="hz-bar-right"
      :class="{ hide: rightFlag, borderRadiusLeft: leftFlag }"
      :style="{
        width: `${calculateRightBar}` + '%',
      }"
      v-b-tooltip.hover
      :title="data.length > 0 ? '$' + data[1].toFixed(2) : ''"
    >
      <span class="bar-right-data">
        {{ inlineData ? '$' + data[1].toFixed(2) : '' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Graph',

  data() {
    return {
      leftFlag: false,
      rightFlag: false,
    };
  },

  props: {
    data: Array,
    inlineData: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    calculateLeftBar() {
      let total = this.data[0] + this.data[1];
      let left = (this.data[0] / total) * 100;

      return left.toFixed(2);
    },

    calculateRightBar() {
      let total = this.data[0] + this.data[1];
      let right = (this.data[1] / total) * 100;

      return right.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.hz-bar-container {
  display: flex;
  width: 100%;
  height: 30px;
  color: white;
  font-weight: 100;

  .hz-bar-left {
    @extend .borderRadiusLeft;
    background-color: $graph-primary;
    padding-right: 15px;
    padding-top: 3px;
    text-align: right;
    .bar-left-data {
      overflow: hidden;
      margin-right: 25px;
      @media print {
        overflow: visible;
      }
    }
  }

  .hz-bar-right {
    @extend .borderRadiusRight;
    background-color: $graph-secondary;
    padding-left: 15px;
    padding-top: 3px;
    .bar-right-data {
      overflow: hidden;
      margin-left: 25px;
      @media print {
        overflow: visible;
      }
    }
  }
}

.hide {
  display: none;
}

.borderRadiusLeft {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  position: relative;
}

.borderRadiusRight {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  position: relative;
}
@media (max-width: 768px) {
  .hz-bar-left {
    font-size: 16px;
  }
  .hz-bar-right {
    font-size: 16px;
  }
}
</style>
